import React, { useEffect, useState } from 'react'
import jwt_decode from "jwt-decode"
import { useParams } from 'react-router-dom';
import { GET_SECTION } from '../../APIS';
import { Error404 } from '../../../../Library/LoaderPage';
import LoadingBtn from '../../../Widgets/LoadingBtn';
import { AlertNotif } from '../../../../Library/AlertNotif';
import { DSession } from './components';

export function DetailClassList() {
    const { token } = useParams();
    try {
        const decode_token = jwt_decode(token);
        const section_id = decode_token.section_id;
        const status = decode_token.status;
        const start_dt = decode_token.start_dt;
        return <DetailClass section_id={section_id} status={status} start_dt={start_dt} />
    } catch (error) {
        return <h3>Error</h3>
    }
}

const DetailClass = ({section_id, status, start_dt}) =>{
    const [section, setSection] = useState({loading:false, data:[], message:""});
    const ReloadData = async () =>{
        setSection({loading:true, data:[], message:""});
        const param = {
            section_id: section_id
        }
        const result = await GET_SECTION(param);
        if(result.data && result.data.length > 0){
            const get_item = result.data.find(item => item.section_id === section_id);
            setSection({loading:false, data: get_item, message:""});
        }else{
            setSection(result);
        }
        
    }

    useEffect(()=>{
        ReloadData();
    },[section_id])

    if(section.loading){
        return <LoadingBtn />
    }else if(section.message){
        return <AlertNotif message={section.message} color="danger" />
    }else if(Object.values(section.data).length > 0){
        return <DSession section={section.data} status={status} start_dt={start_dt} />
    }else{
        return <Error404 />
    }

    
}
